import { Col, Row } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const SponsorshipMembership = ({
  formProps,
  values,
  setPercent,
  isFieldRequired,
  initialValues,
  errors,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP}-section`}
    >
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <Input
              optional={SUBSCRIPTION.FORM.OPTIONAL}
              placeholder={
                SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.REFERRAL.PLACEHOLDER
              }
              label={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.REFERRAL.LABEL}
              icon={<MdOutlineFreeCancellation size={16} />}
              defaultValue={get(initialValues, "additionalInfo.referralCode")}
              errors={errors["additionalInfo.referralCode"]}
              touched={!isEmpty(errors["additionalInfo.referralCode"])}
              onBlur={() => setPercent(initialValues)}
              onChange={({ target: { value } }) => {
                set(initialValues, "additionalInfo.referralCode", value);
              }}
              required={isFieldRequired("additionalInfo.referralCode")}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SponsorshipMembership;
